import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { ReportProvider } from '../../providers/report/report';
import { globalDefines } from '../../app/app.constants';


@IonicPage()
@Component({
  selector: 'page-report-global',
  templateUrl: 'report-global.html',
})
export class ReportGlobalPage {

  users;
  beginMonth;
  endMonth;

  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public reportProvider: ReportProvider,
    public toastCtrl: ToastController,
  ) {

    let now = new Date()
    let month = new Date(now.getFullYear(), now.getMonth(), 1, 2, 0, 0, 0)
    month.setMinutes(month.getMinutes() - new Date().getTimezoneOffset())

    this.beginMonth = month.toISOString();
    this.endMonth = month.toISOString();
  }

  generate() {
    if(this.beginMonth && this.endMonth) {
      let loading = this.loadingCtrl.create();
      loading.present();
      
      this.reportProvider.globalReport(this.beginMonth, this.endMonth)
        .then(() => loading.dismiss())
        .catch(error => loading.dismiss())
    }
    else this.showMessage('Introduzca todos los datos.');
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-global/report-global.ts